import { Backdrop, Modal } from '@mui/material';
import { ChangeEvent, FC, useState } from 'react';
import ModalAction from 'src/components/Items/modal/Actions';
import SimpleMultiSelect from 'src/components/Items/select/SimpleMultiSelect';
import { useActions } from 'src/hooks/useActions';
import { IOrderFetch } from 'src/models/IOrder';
interface IProps {
  handleClose: () => void;
  open: boolean;
  order: IOrderFetch;
}
const DocumentModal: FC<IProps> = ({ handleClose, open, order }) => {
  const { updateClient, updateOrder } = useActions();
  const [document, setDocument] = useState<string[]>([]);
  const documentArray = ['license', 'contract'];
  const handleChange =
    (type: any) => (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      type(typeof value === 'string' ? value.split(',') : value);
    };
  const handleSubmit = (value: string[]) => {
    if (value.length) {
      if (value.includes('license')) {
        updateClient({
          id: order.client.id,
          driver_license_id: null,
        });
      } else if (value.includes('contract')) {
        updateOrder({ id: order.id, pdf_order: '' });
      }
    }
  };
  return (
    <Modal
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      onClose={handleClose}
    >
      <div className='modal modal-400'>
        <div className='modal__title'>Delete documents</div>
        <div style={{ marginBottom: '40px' }}>
          <SimpleMultiSelect
            dataArray={documentArray}
            title='documents'
            data={document}
            variant='outlined'
            setData={handleChange(setDocument)}
          />
        </div>
        <ModalAction
          handleClose={handleClose}
          type='document'
          action='Delete'
          handleSubmit={() => handleSubmit(document)}
        />
      </div>
    </Modal>
  );
};
export default DocumentModal;
